export default __webpack_public_path__ + "static/char-s-13-kr-c129f7667c1a6dea3d76ffaaf66cd4fe.png";